import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CoreCommonModule } from "src/@core/common.module";
import { CoreMenuModule } from "src/@core/components";
import { VerticalMenuComponent } from "./vertical-menu.component";

// import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
// import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
// import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";


// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true,
//   wheelPropagation: false,
// };
@NgModule({
  declarations: [VerticalMenuComponent],
  imports: [
    CoreMenuModule,
    CoreCommonModule,
    // PerfectScrollbarModule,
    RouterModule,
  ],
  providers: [
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    // },
  ],
  exports: [VerticalMenuComponent],
})
export class VerticalMenuModule {}
